(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-private-order-confirm]').forEach((checkbox) => {
      if (checkbox.dataset.bound) return;
      checkbox.dataset.bound = 'true';
      const area = checkbox.closest('[data-private-order]');
      const controls = area?.querySelectorAll('[data-private-payment]');
      const sync = () => controls?.forEach((control) => {
        control.toggleAttribute('disabled', !checkbox.checked);
        control.setAttribute('aria-disabled', String(!checkbox.checked));
      });
      checkbox.addEventListener('change', sync);
      sync();
    });

    root.querySelectorAll('[data-lc-sticky-buy]').forEach((bar) => {
      if (bar.dataset.bound) return;
      bar.dataset.bound = 'true';
      const target = document.querySelector(bar.dataset.target);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting; }, { threshold: .1 }).observe(target);
      bar.querySelector('button')?.addEventListener('click', () => target.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    });

    root.querySelectorAll('[data-lc-carousel]').forEach((carousel) => {
      if (carousel.dataset.bound) return;
      carousel.dataset.bound = 'true';
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const interval = Number(carousel.dataset.interval) || 4800;
      let timer;
      const advance = () => {
        const firstCard = carousel.firstElementChild;
        if (!firstCard || carousel.scrollWidth <= carousel.clientWidth) return;
        const gap = parseFloat(getComputedStyle(carousel).gap) || 0;
        const step = firstCard.getBoundingClientRect().width + gap;
        const atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - step / 2;
        carousel.scrollTo({ left: atEnd ? 0 : carousel.scrollLeft + step, behavior: 'smooth' });
      };
      const start = () => { clearInterval(timer); timer = setInterval(advance, interval); };
      const stop = () => clearInterval(timer);
      carousel.addEventListener('pointerdown', stop, { passive: true });
      carousel.addEventListener('pointerup', start, { passive: true });
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      start();
    });

    root.querySelectorAll('[data-process-timeline]').forEach((timelineRoot) => {
      if (timelineRoot.dataset.bound) return;
      timelineRoot.dataset.bound = 'true';
      const timeline = timelineRoot.querySelector('.rl-process__timeline');
      const steps = [...timelineRoot.querySelectorAll('[data-process-step]')];
      const panels = [...timelineRoot.querySelectorAll('[data-process-panel]')];
      const previous = timelineRoot.querySelector('[data-process-prev]');
      const next = timelineRoot.querySelector('[data-process-next]');
      if (!timeline || !steps.length || steps.length !== panels.length) return;
      let activeIndex = 0;

      const activate = (index, moveFocus = false) => {
        const safeIndex = (index + steps.length) % steps.length;
        activeIndex = safeIndex;
        steps.forEach((step, stepIndex) => {
          const active = stepIndex === safeIndex;
          step.classList.toggle('is-active', active);
          step.setAttribute('aria-selected', String(active));
          step.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === safeIndex;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
        const progress = steps.length > 1 ? (safeIndex / (steps.length - 1)) * 100 : 0;
        timeline.style.setProperty('--process-progress', `${progress}%`);
        if (moveFocus) steps[safeIndex].focus({ preventScroll: true });
      };

      steps.forEach((step, index) => {
        step.addEventListener('click', () => activate(index));
        step.addEventListener('keydown', (event) => {
          let targetIndex;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = index + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = index - 1;
          if (event.key === 'Home') targetIndex = 0;
          if (event.key === 'End') targetIndex = steps.length - 1;
          if (targetIndex === undefined) return;
          event.preventDefault();
          activate(targetIndex, true);
        });
      });
      previous?.addEventListener('click', () => activate(activeIndex - 1));
      next?.addEventListener('click', () => activate(activeIndex + 1));

      let touchStartX = 0;
      const panelArea = timelineRoot.querySelector('.rl-process__panels');
      panelArea?.addEventListener('touchstart', (event) => {
        touchStartX = event.touches[0]?.clientX || 0;
      }, { passive: true });
      panelArea?.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX || 0;
        const distance = touchEndX - touchStartX;
        if (Math.abs(distance) < 45) return;
        activate(activeIndex + (distance < 0 ? 1 : -1));
      }, { passive: true });
      activate(0);
    });

    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { threshold: .12, rootMargin: '0px 0px -30px' });
      root.querySelectorAll('.rl-section, .rl-assurance, .rl-path, .rl-stage, .rl-promise, .raina-footer-brand').forEach((element, index) => {
        if (element.dataset.revealBound) return;
        element.dataset.revealBound = 'true';
        element.classList.add('rl-reveal');
        element.style.setProperty('--rl-delay', `${Math.min(index % 4, 3) * 70}ms`);
        revealObserver.observe(element);
      });
    }
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
